import { render, staticRenderFns } from "./PaginationBasic.vue?vue&type=template&id=1048a03c&"
import script from "./PaginationBasic.vue?vue&type=script&lang=js&"
export * from "./PaginationBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports